import cloneDeep from 'lodash/cloneDeep';
import Contact from '@/classes/v2/Contact';
import SmsNumber from '@/classes/SmsNumber';
import Provider from '@/classes/v2/Provider';

const currentUser = state => {
  return new Contact({
    ...state,
    number: state.activeNumber?.number,
    type: state.activeNumber?.type,
    userId: state.userId
  });
};

const activeNumber = state => {
  const activeNumber = cloneDeep(state.activeNumber);
  return activeNumber ? new SmsNumber(activeNumber) : null;
};

const activeProvider = (state, getters) => {
  const activeNumber = getters.activeNumber;
  if (!activeNumber) {
    // Return default provider.
    return new Provider({});
  }

  return activeNumber.provider;
};

const getActiveNumbers = state => {
  return state.numbers.filter(num => num.active === true).map(n => new SmsNumber(n));
};

const getNumbers = state => {
  return state.numbers?.map(n => new SmsNumber(n));
};

const getUser = state => {
  return cloneDeep(state);
};

const getUserId = state => {
  return cloneDeep(state.userId);
};

const userLinkId = state => {
  return cloneDeep(state.id);
};

const getUserName = (state, getters, rootState, rootGetters) => {
  const lang = rootGetters['preferences/userLocale'];
  const name = `${state.firstName} ${state.lastName}`.trim();
  const me = lang === 'en' ? 'Me' : 'Mí';
  return `${name} (${me})`;
};

const getUserToken = state => {
  return cloneDeep(state.token);
};

export default {
  currentUser,
  activeNumber,
  activeProvider,
  getActiveNumbers,
  getNumbers,
  getUser,
  getUserId,
  userLinkId,
  getUserName,
  getUserToken
};
